import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

interface ContainerProps {
  type?: 'success' | 'error' | 'info';
  hasDescription: number;
}

const toastTypeVariations = {
  info: css`
    background: var(--color-neutral-light);
    color: var(--color-neutral-dark);
  `,
  success: css`
    background: var(--color-support-success-light);
    color: var(--color-support-success-dark);
  `,
  error: css`
    background: var(--color-support-danger-light);
    color: var(--color-support-danger-dark);
  `,
};

export const Container = styled(animated.div)<ContainerProps>`
  /*  width: 360px; */

  position: relative;
  padding: var(--spacing-inline-xs) var(--spacing-inline-md)
    var(--spacing-inline-xs) var(--spacing-inline-xs); /* 16px 30px 16px 16px */
  border-radius: var(--border-radius-xs);
  border: var(--theme-border-width-thin) solid var(--color-neutral-dark);

  display: flex;

  & + div {
    margin-top: var(--spacing-stack-xxs); /* 8px */
  }

  ${(props) => toastTypeVariations[props.type || 'info']};

  > span {
    margin: 0 var(--spacing-stack-xs) 0 0; /* 0 12px 0 0 */
  }

  div {
    flex: 1;

    p {
      margin-top: var(--spacing-stack-xxxs); /* 4px */
      font-size: var(--font-size-xxs); /* 14px */
      opacity: var(--opacity-semi-opaque); /* 0.8 */
      line-height: var(--font-line-height-xxs); /* 20px */
    }
  }

  button {
    position: absolute;
    right: var(--spacing-inline-xs); /* 16px */
    top: var(--spacing-inline-xs); /* 16px */
    border: 0;
    background: transparent;
    color: inherit;
    /* opacity: 0.6; */
  }

  ${(props) =>
    !props.hasDescription &&
    css`
      align-items: center;

      svg {
        margin-top: 0;
      }
    `}
`;
